export const FIRESTORE_RANDOM_ID_LENGTH = 20;

// https://firebase.google.com/docs/firestore/quotas#writes_and_transactions
export const MAX_MESSAGES_PER_BATCH = 500;

// https://firebase.google.com/docs/firestore/query-data/queries#limits_on_or_queries
// TODO: upgrade firebase client and increase to 30
export const MAX_CLAUSES_PER_QUERY = 10;
